export const shopify_sort_options = [
  { value: "relevance|desc", label: "Sort By: Relevance" },
  { value: "title|asc", label: "Title: A-Z" },
  { value: "title|desc", label: "Title: Z-A" },
  { value: "price|desc", label: "Price: High to Low" },
  { value: "price|asc", label: "Price: Low to High" },
  { value: "discount|desc", label: "Discount: High to Low" },
  { value: "discount|asc", label: "Discount: Low to High" },
  { value: "rating|desc", label: "Rating: High to Low" },
  { value: "bestselling|desc", label: "Bestselling" },
];

export const langOptions = [
  { value: "0", label: "English" },
  { value: "1", label: "English + Hindi" },
  { value: "2", label: "English + Spanish" },
  { value: "3", label: "English + German" },
];

export const suggestedOptions = {
  English: ["Pokemon", "Monopoly", "Funko", "Crayalo"],
  "English + Hindi": ["enghin", "enghin", "enghin", "enghin"],
  "English + Spanish": ["engSpa", "engSpa", "engSpa", "engSpa"],
  "English + German": ["engGer", "engGer", "engGer", "engGer"],
};
